export function percentageNormalize(values, minPercentage) {
  const total = values.reduce((sum, item) => sum + item[1], 0);
  if (total === 0) return values;

  const percentValues = values.map(([color, value]) => [color, value / total]);

  const smallValues = percentValues.filter((item) => item[1] < minPercentage);
  if (smallValues.length === 0) return percentValues;

  const excess = smallValues.reduce(
    (sum, item) => sum + (minPercentage - item[1]),
    0
  );

  const largestItem = percentValues
    .filter((item) => item[1] >= minPercentage)
    .reduce((max, item) => (item[1] > max[1] ? item : max), ["#000", 0]);

  if (largestItem[1] === 0) return percentValues;

  return percentValues.map((item) => {
    if (item[1] < minPercentage) {
      return [item[0], minPercentage];
    }
    if (item[0] === largestItem[0]) {
      return [item[0], Math.max(minPercentage, item[1] - excess)];
    }
    return item;
  });
}
